import { Model } from '@models/model';
import { Paginated } from '../paginated';

export class UserDomain extends Model {
  idDomain: number;
  idZone: string;
  ipAddress: string;
  name: string;
  idUserDomain: number;
  subDomainName: string;
  domain: string;
}

export class UserDomains extends Paginated {
  data: Array<UserDomain>;
}
